var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLines4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 909 335.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.2,67.66c50.39-21.78,86.65,37.33,238.61,87.4,135.27,27.23,135.27,14.38,192.37-47.43,34.26-39.97,153.49-175.87,265.27-63.68,44.68,38.74,210.52,208.57,212.29,207.51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.2,113.33c46.85-20.04,134.52,47.87,213.57,65.88,140.1,30.9,175.24,16.25,205.98-10.1,20.83-19.38,68.95-69.39,90.03-92.67,35.14-31.62,36.45-40.84,103.65-40.84,59.29,6.15,109.36,72.36,155.47,121.22,43.48,39.09,135.52,133.95,139.83,135.27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.2,148.03c43.11-17.7,189.55,91,354.99,77.74,75.98-7.03,91.35-40.11,155.03-107.6,53.58-48.31,107.16-73.35,186.22,13.18,28.55,28.11,210.77,204.22,212.29,203.35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines4);
export default __webpack_public_path__ + "static/media/lines_4.c7f1d6de04205972cb6586fac1760df0.svg";
export { ForwardRef as ReactComponent };